<template>
  <div>
  <span class="title">{{$t('Seleccione idioma')}}</span>
    <div class="languages">
      <button v-on:click="() => handleChange('en')">
        <img src="@/assets/flags/en.jpg" alt="English">
      </button>

      <button v-on:click="() => handleChange('es')">
        <img src="@/assets/flags/es.png" alt="English">
      </button>
    </div>
  </div>
</template>

<script>
import { Trans } from '@/helpers/i18n';

export default {
  name: 'TranslationSwitch',
  data() {
    return {
      options: [{
        value: 'es',
        label: 'es',
      }, {
        value: 'en',
        label: 'en',
      }],
    };
  },
  methods: {
    handleChange(lang) {
      const currentLang = this.$i18n.locale;
      const currentPath = this.$router.history.current.path;

      this.$router.push(currentPath.replace(`/${currentLang}`, `/${lang}`));

      Trans.changeLanguage(lang);
    },
  },
};
</script>

<style scoped>
  .title {
    color: #fff;
    font-weight: 300;
  }

 .languages {
   display: flex;
   justify-content: center;
   align-items: center;
   margin-top: 5px;
 }

  .languages button {
    width: 40px;
    height: 25px;
    overflow: hidden;
    border-radius: 2px;
    margin: 0 10px;
    padding: 0;
    border: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .1);
    cursor: pointer;
  }

  .languages button img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
